import { useMutation } from '@tanstack/react-query';

import CategoryApi from '../../../lib/api/category/CategoryApi';
import { reDirectPage, setDetailPageUrl } from '../../../lib/common';
import { CATEGORY_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';
import toastMsg from '../../../lib/toastMsg';
import { extractErrorMessage } from '../../../lib/utils/checkErrorResponse';

/**
 * 카테고리를 생성하는 mutation hook
 * @return {{createCategory: UseMutationResult<unknown, unknown, void, unknown>}}
 */
const useCreateCategory = () => {
  const createCategory = useMutation({
    mutationFn: (data) => CategoryApi.createCategory(data),
    onSuccess: (data) => reDirectPage({ path: setDetailPageUrl(CATEGORY_DETAIL_URL_PATH, data.category.id) }),
    onError: (error) => {
      toastMsg.error(extractErrorMessage(error));
    },
  });

  return { createCategory };
};

export default useCreateCategory;
